import { gql } from "@apollo/client";

export const GET_STATES = gql`
  query GetStates($nationalId: String!) {
    states(nationalId: $nationalId) {
      _id
      name
      orgtree {
        national {
          _id
          name
        }
      }
      meta {
        avatar
      }
    }
  }
`;

export const GET_REGIONS = gql`
  query GetRegion($stateId: Int!, $nationalId:Int!) {
    regions(stateId: $stateId, nationalId:$nationalId) {
      _id
      name
      orgtree {
        state {
          _id
          name
        }
      }
      meta {
        avatar
      }
    }
  }
`;

export const GET_ASSOCIATIONS = gql`
  query GetAssociationsByRegion($regionId: Int!, $nationalId:Int!) {
    associationsByRegion(regionId: $regionId, nationalId:$nationalId) {
      _id
      name
      orgtree {
        state {
          _id
          name
          type
        }
      }
      meta {
        avatar
      }
    }
  }
`;

export const TEAM_SEARCH = gql`
  query SearchFilterTeam($type: String!, $criteria: String!, $nationalId: Int!) {
    search(type: $type, criteria: $criteria, nationalId: $nationalId) {
      team {
        _id
        name
        orgtree {
          national {
            _id
            name
          }
        }
        season
        club
        association
        competition
        meta {
          abbreviation
          avatar
        }
      }
    }
  }
`;

export const CLUB_SEARCH = gql`
  query SearchFilterClub($type: String!, $criteria: String!, $nationalId: Int!) {
    search(type: $type, criteria: $criteria, nationalId: $nationalId) {
      club {
        _id
        name
        meta {
          avatar
        }
        association
        orgtree {
        state {
          _id
          name
          type
        }
          region {
          _id
          name
          type
        }
          association {
          _id
          name
          type
        }
      }
        contact{
            address{
                suburb
            }
        }
      }
    }
  }
`;

export const ASSOCIATION_SEARCH = gql`
  query SearchFilterAssociation($type: String!, $criteria: String!, $nationalId: Int!) {
    search(type: $type, criteria: $criteria, nationalId: $nationalId) {
      association {
        _id
        name
        orgtree {
          state {
            _id
            name
          }
          region {
            _id
            name
          }
        }
        meta {
          avatar
        }
        contact {
          name
          number
          email
          address {
            formatted
            lat
            lng
            addressLine1
            addressLine2
            suburb
            state
            postcode
            country
          }
        }
      }
    }
  }
`;

export const COMPETITION_SEARCH = gql`
  query SearchFilterCompetition($type: String!, $criteria: String!, $nationalId: Int!) {
    search(type: $type, criteria: $criteria, nationalId: $nationalId) {
      competition {
        name
        association {
        meta{
            avatar
          }
          name
          orgtree {
            state {
              _id
              name
              type
            }
          }
          _id
          contact {
            name
            address {
              formatted
              suburb
              state
              postcode
              country
              lat
              lng
              addressLine1
            }
          }
        }
        _id
        meta {
          enableAwards
          maxNoTeams
          elite
          avatar
        }
        orgtree {
        state {
          _id
          name
          type
        }
          region {
          _id
          name
          type
        }
          association {
          _id
          name
          type
        }
      }
      }
    }
  }
`;

export const GET_COMPETITION_LADDER = gql`
  query CompetitionLadder($competitionId: Int!) {
    competitionLadder(competitionId: $competitionId) {
      teams {
        _id
        name
        ageLvl
        pool
        avatar
        stats {
          totalMatchPoints
          pointsDifference
          pointsFor
          pointsAgainst
          matchesPlayed
          matchesWon
          matchesLost
          matchesDrawn
          byes
          pointsForADJ
          pointsAgainstADJ
          pointsADJ
          totalTries
          scoreRatio
          pointsRatio
          matchWinRatio
          percentage
          numberOfForfeits
          numberForfeitsWin
          numberForfeitsLoss
        }
      }
    }
  }
`;

export const GET_COMPETITION_STATS = gql`
  query Playerstats($competitionId: Int!, $nationalId: Int!) {
    playerstats(competitionId: $competitionId, nationalId: $nationalId) {
      _id
      memberId
      fieldGoals
      fieldGoals2pt
      games
      goals
      tries
      totalPoints
      team {
        _id
        name
        orgtree {
          state {
            _id
            name
          }
          region {
            _id
            name
          }
          association {
            _id
            name
          }
          club {
            _id
            name
          }
        }
        logo
      }
      player {
        _id
        firstName
        lastName
        isPrivate
      }
    }
  }
`;
export const ALL_SEARCH = gql`
  query SearchFilterAll($type: String!, $criteria: String!, $nationalId: Int!) {
    search(type: $type, criteria: $criteria, nationalId: $nationalId) {
      competition {
        name
        association {
        meta{
            avatar
          }
          name
          orgtree {
            state {
              _id
              name
              type
            }
          }
          _id
          contact {
            name
            address {
              formatted
              suburb
              state
              postcode
              country
              lat
              lng
              addressLine1
            }
          }
        }
        _id
        meta {
          enableAwards
          maxNoTeams
          elite
          avatar
        }
      }

      team {
        _id
        name
        orgtree {
          national {
            _id
          }
        }
        season
        club
        association
        competition
        meta {
          abbreviation
          avatar
        }
      }

      association {
        _id
        name
        orgtree {
          state {
            _id
            name
          }
          region {
            _id
            name
          }
        }
        meta {
          avatar
        }
        contact {
          name
          number
          email
          address {
            formatted
            lat
            lng
            addressLine1
            addressLine2
            suburb
            state
            postcode
            country
          }
        }
      }

      club {
        _id
        name
        meta {
          avatar
        }
        association
        contact{
            address{
                suburb
            }
        }
      }
    }
  }
`;

export const GET_MATCH_STATS = gql`
  query getMatchInfo($matchId: Int!) {
    match(matchId: $matchId) {
      season
      dateTime
      scores {
        homeTeam
        awayTeam
      }
      status
      homeTeam {
        _id
        name
        avatar
      }
      awayTeam {
        _id
        name
        avatar
      }
      scoringEvents {
        _id
        name
        type
        value
        teamId
        isHomeTeam
        min
        sec
        meta {
          player {
            _id
            shirtNum
            firstName
            lastName
            middleName
            preferredName
            isPrivate
            isCaptain
          }
        }
      }
      playerMovements {
        _id
        name
        type
        teamId
        isHomeTeam
        min
        sec
        meta {
          off {
            _id
            shirtNum
            firstName
            lastName
            middleName
            preferredName
            isPrivate
            isCaptain
          }
          on {
            _id
            shirtNum
            firstName
            lastName
            middleName
            preferredName
            isPrivate
            isCaptain
          }
        }
      }
      competition {
        _id
        name
        avatar
      }
      round {
        number
        type
        displayName
      }
      meta {
        isTba
        isBye
        fieldNo
        liveUrl
        liveDateTime
      }
      venue {
        _id
        name
        venueTimezone
      }
      awayTeamList {
        _id
        season
        matchid
        isHomeTeam
        status
        createdBy
        createdAt
        modifiedAt
        modifiedBy
        competition {
          _id
          name
        }
        team {
          _id
          name
        }
        players {
          _id
          shirtNum
          firstName
          lastName
          middleName
          preferredName
          isPrivate
          isCaptain
          position {
            name
            abbreviation
            number
            order
          }
          tries
          games
          meta {
            avatar
          }
        }
        nonplayers {
          _id
          shirtNum
          firstName
          lastName
          middleName
          preferredName
          isPrivate
          role
          meta {
            avatar
          }
        }
      }
      homeTeamList {
        _id
        season
        matchid
        isHomeTeam
        status
        createdBy
        createdAt
        modifiedAt
        modifiedBy
        nonplayers {
          _id
          shirtNum
          firstName
          lastName
          middleName
          preferredName
          isPrivate
          role
          meta {
            avatar
          }
        }
        players {
          _id
          shirtNum
          firstName
          lastName
          middleName
          preferredName
          isPrivate
          isCaptain
          tries
          games
          meta {
            avatar
          }
          position {
            name
            abbreviation
            number
            order
          }
        }
        team {
          _id
          name
        }
        competition {
          _id
          name
        }
      }
      _id
      fullVenue {
            _id
            name
            venueTimezone
            address {
                formatted
                lat
                lng
                addressLine1
                addressLine2
                suburb
                state
                postcode
                country
            }
        }
    }
  }
`;
